<template>
  <workflow-review-status-inline
    v-if="shouldRenderInline"
    :has-any-up-to-date-review="hasAnyUpToDateReview"
    :has-up-to-date-review-by-user="hasUpToDateReviewByUser"
    :reviewed="reviewed"
    :reviews-to-show="reviewsToShow"
    :tracking-prefix="trackingPrefix"
    @mark-as-reviewed="markAsReviewed"
    @unmark="unmark"
  />

  <workflow-review-status-block
    v-else
    :has-any-up-to-date-review="hasAnyUpToDateReview"
    :has-up-to-date-review-by-user="hasUpToDateReviewByUser"
    :reviewed="reviewed"
    :reviews-to-show="reviewsToShow"
    :tracking-prefix="trackingPrefix"
    @mark-as-reviewed="markAsReviewed"
    @unmark="unmark"
  />
</template>

<script>
import SFetch from '@app/utils/sfetch'
import WorkflowReviewStatusInline from '@app/application/workflows/screens/workflow-review/components/workflow-review-status-inline.vue'
import WorkflowReviewStatusBlock from '@app/application/workflows/screens/workflow-review/components/workflow-review-status-block.vue'

const WorkflowReviewStatus = {
  props: [
    'parentId',
    'review',
    'reviews',
    'ledgerId',
    'itemClass',
    'itemId',
    'trackingPrefix',
    'shouldRenderInline',
  ],
  emits: ['item-review-update'],
  components: { WorkflowReviewStatusInline, WorkflowReviewStatusBlock },
  computed: {
    reviewed() {
      return this.reviews && this.reviews.length > 0
    },
    reviewedByUser() {
      return !!this.review
    },
    hasAnyUpToDateReview() {
      return (
        this.reviewed &&
        this.reviews.some((review) => review.outdatedAt === null)
      )
    },
    hasUpToDateReviewByUser() {
      return this.reviewedByUser && this.review.outdatedAt === null
    },
    reviewsToShow() {
      if (this.hasAnyUpToDateReview) {
        // List only the up-to-date reviews
        return this.reviews.filter((review) => review.outdatedAt === null)
      } else {
        // List all reviews
        return this.reviews
      }
    },
  },
  methods: {
    markAsReviewed() {
      const url = Silverfin.Routes.create_ledger_workflow_reviews_path(
        Silverfin.currentFirmId,
        Silverfin.currentCompanyId,
        this.ledgerId,
        this.itemClass,
        this.itemId
      )
      SFetch.jsonWithAlert(url, { method: 'POST' }).then((data) => {
        const { reviews, review } = data

        this.$emit('item-review-update', {
          itemId: this.itemId,
          itemClass: this.itemClass,
          parentId: this.parentId,
          review,
          reviews,
        })
      })
    },
    unmark() {
      const url = Silverfin.Routes.destroy_ledger_workflow_reviews_path(
        Silverfin.currentFirmId,
        Silverfin.currentCompanyId,
        this.ledgerId,
        this.itemClass,
        this.itemId,
        this.review.id
      )
      SFetch.jsonWithAlert(url, { method: 'DELETE' }).then((data) => {
        const { reviews, review } = data

        this.$emit('item-review-update', {
          itemId: this.itemId,
          itemClass: this.itemClass,
          parentId: this.parentId,
          review,
          reviews,
        })
      })
    },
  },
}

export default WorkflowReviewStatus
</script>
